import axios, { AxiosError, AxiosInstance } from "axios"
import { JobApplicationPayload } from "../interfaces/Placements";

const BASE_URL = 'https://placement-portal-dev-api.ken42.com/'
// const BASE_URL = 'http://localhost:3000/'

type RetriableConfig = {
  _retry?: boolean;
};

export const getAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem('KEY_ACCESS_TOKEN');
      if (accessToken) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const originalRequest = (error.config || {}) as typeof error.config & RetriableConfig;
      if (!error.response) {
        return Promise.reject(error);
      }
      const isRefreshCall = originalRequest?.url?.includes('/api/auth/refresh');
      if (error.response.status === 401 && !originalRequest?._retry && !isRefreshCall) {
        originalRequest._retry = true;
        try {
          const refreshToken = localStorage.getItem('KEY_REFRESH_TOKEN');
          if (!refreshToken) throw new Error('No refresh token');
          const res = await axios.post(`${BASE_URL}api/auth/refresh`, null, {
            headers: { 'x-refresh-token': refreshToken },
          });
          const newAccessToken = (res.data as any)?.accessToken;
          if (!newAccessToken) throw new Error('No access token in refresh response');
          localStorage.setItem('KEY_ACCESS_TOKEN', newAccessToken);
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshErr) {
          localStorage.clear();
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
}



export let axiosInstance: AxiosInstance = getAxiosInstance();

export const LoginWithOtp = async(email:string) => {
  const path = `api/auth/otp/send?contact=${email}`
  const res = await axiosInstance.post(path,{})
  return res.data
}

export const verifyOtp = async(email:string, otp:string) => {
  const path = `api/auth/otp/verify?contact=${email}&otpentered=${otp}`
  const res = await axiosInstance.get(path)
  return res.data
}
export const getAllJobs = async() => {
    const path = 'api/sf/all/jobs'
    const res = await axiosInstance.get(path)
    return res.data
}

export const getApplications = async(id:string) => {
    const path = `api/sf/jobApplicationsByContact/${id}`
    const res = await axiosInstance.get(path)
    return res.data
}
export const getResumesById = async(id:string) => {
    const path = `api/sf/resumesByContact/${id}`
    const res = await axiosInstance.get(path)
    return res.data
}

export const postApplication = async(payload:JobApplicationPayload[]) => {
  const path = "api/sf/jobApplicationsByContact"
  const res = await axiosInstance.post(path, payload)
  return res.data
}

export const uploadResume = async(payload:{contactId: string;
  fileName: string;
  base64Data: string;}) => {
    const path = 'api/sf/resumesByContact';
    const res = await axiosInstance.post(path, payload);
    return res.data;
  }

  export const getApplicantById = async (id: string) => {
    const path = `api/sf/Getcontactbyid/${id}`;
    const res = await axiosInstance.get(path);
    return res.data;
  };